import React, { useState } from "react";
import { Space, Switch, Table, TableProps } from "antd";
import type { TableColumnsType } from "antd";
import { useNavigate } from "react-router-dom";

interface DataType {
  key: React.ReactNode;
  name: string;
  price?: number;
  seller?: string;
  unit?: number;
  url: string;
  date: string;
}
type TableRowSelection<T extends object = object> =
  TableProps<T>["rowSelection"];

function randomDate(start: any, end: any) {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
}

const d = randomDate(new Date(2012, 0, 1), new Date());
console.log(d);

const data: DataType[] = [
  {
    key: 1,
    name: "Вода",
    date: new Date().toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 2,
    name: "Вода",
    date: new Date(new Date().getTime() - 11111111).toLocaleString(),
    url: "1",
    unit: 60,
  },
  {
    key: 3,
    name: "Вода",
    date: new Date(new Date().getTime() - 15555555).toLocaleString(),
    url: "1",
    unit: 200,
  },
  {
    key: 4,
    name: "Вода",
    date: new Date(new Date().getTime() - 88888888).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 5,
    name: "Вода",
    date: new Date(new Date().getTime() - 89999999).toLocaleString(),
    url: "1",
    unit: 140,
  },
  {
    key: 6,
    name: "Вода",
    date: new Date(new Date().getTime() - 99999999).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 7,
    name: "Вода",
    date: new Date(new Date().getTime() - 111111111).toLocaleString(),
    url: "1",
    unit: 60,
  },
  {
    key: 8,
    name: "Вода",
    date: new Date(new Date().getTime() - 125555555).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 9,
    name: "Вода",
    date: new Date(new Date().getTime() - 135555555).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 10,
    name: "Вода",
    date: new Date(new Date().getTime() - 145555555).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 11,
    name: "Вода",
    date: new Date(new Date().getTime() - 188888888).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 12,
    name: "Вода",
    date: new Date(new Date().getTime() - 189999999).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 13,
    name: "Вода",
    date: new Date(new Date().getTime() - 199999999).toLocaleString(),
    url: "1",
    unit: 100,
  },
  {
    key: 14,
    name: "Вода",
    date: new Date(new Date().getTime() - 1111111111).toLocaleString(),
    url: "1",
    unit: 100,
  },
];

// rowSelection objects indicates the need for row selection
const rowSelection: TableRowSelection<DataType> = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};

const HistorySearch: React.FC = () => {
  const navigate = useNavigate();

  const columns: TableColumnsType<DataType> = [
    { title: "Дата поиска", dataIndex: "date", key: "date" },
    { title: "Тип товара", dataIndex: "name", key: "name" },
    { title: "Количество", dataIndex: "unit", key: "unit" },
    {
      title: "Результаты поиска",
      dataIndex: "url",
      key: "url",
      render: (url) => (
        <>{<a onClick={() => navigate(`/search?type=${url}`)}>Просмотр</a>}</>
      ),
    },
  ];

  return (
    <div className="App">
      <div className="white-back">
        <Table<DataType> columns={columns} dataSource={data} />
      </div>
    </div>
  );
};

export default HistorySearch;
